module.exports = "<svg id=menu-play data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 122 89\"> <defs> <style>.cls-5{fill:#565656}</style> </defs> <path class=cls-5 d=M76.81,47.28c2.65-1.53,2.65-4,0-5.56L53.32,28.15c-2.65-1.53-4.82-.28-4.82,2.78V58.06c0,3.06,2.17,4.31,4.82,2.78Z /> </svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/play_menu-01.svg
// module id = MQZk
// module chunks = 3 4